import React from 'react';
import { TeamDetailPage } from './TeamDetailPage';

/**
 * `/app/teams/:teamId/members` — kept for existing links. It opens the same student
 * gradebook (and, on phones, the same group screen) as the group's base route.
 */
export const TeamMembersPage: React.FC = () => <TeamDetailPage />;

export default TeamMembersPage;
